import React, { useState } from 'react';
import api from '../../services/api';
import { toast } from 'react-toastify';

export default function MemberSettings() {
  const [passwords, setPasswords] = useState({ old_password: '', new_password: '', confirm: '' });
  const [loading, setLoading] = useState(false);

  const handleChangePassword = async (e) => {
    e.preventDefault();
    if (passwords.new_password !== passwords.confirm) {
      toast.error('New passwords do not match.');
      return;
    }
    setLoading(true);
    try {
      await api.post('/accounts/change-password/', {
        old_password: passwords.old_password,
        new_password: passwords.new_password,
      });
      toast.success('Password changed successfully!');
      setPasswords({ old_password: '', new_password: '', confirm: '' });
    } catch (err) {
      toast.error(err.response?.data?.old_password?.[0] || 'Failed to change password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-2xl">
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Account Settings</h1>

      <div className="bg-white rounded-xl shadow-sm border p-8">
        <h2 className="text-lg font-semibold text-gray-900 mb-6">Change Password</h2>
        <form onSubmit={handleChangePassword} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-500 mb-1">Current Password</label>
            <input type="password" required value={passwords.old_password}
              onChange={(e) => setPasswords({ ...passwords, old_password: e.target.value })}
              className="w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-[#0B5D1E] outline-none" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-500 mb-1">New Password</label>
            <input type="password" required minLength={8} value={passwords.new_password}
              onChange={(e) => setPasswords({ ...passwords, new_password: e.target.value })}
              className="w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-[#0B5D1E] outline-none" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-500 mb-1">Confirm New Password</label>
            <input type="password" required value={passwords.confirm}
              onChange={(e) => setPasswords({ ...passwords, confirm: e.target.value })}
              className="w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-[#0B5D1E] outline-none" />
          </div>
          <button type="submit" disabled={loading}
            className="bg-[#0B5D1E] text-white px-6 py-2.5 rounded-lg font-semibold hover:bg-[#062E10] transition disabled:opacity-50">
            {loading ? 'Changing...' : 'Change Password'}
          </button>
        </form>
      </div>
    </div>
  );
}
